<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 18 18">
    <path
      d="M1 4C1 3.06812 1 2.60218 1.15224 2.23463C1.35523 1.74458 1.74458 1.35523 2.23463 1.15224C2.60218 1 3.06812 1 4 1H14C14.9319 1 15.3978 1 15.7654 1.15224C16.2554 1.35523 16.6448 1.74458 16.8478 2.23463C17 2.60218 17 3.06812 17 4M6 17H12M9 1V17"
      :class="colorClass"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
